'use client';

import { createContext, useContext } from 'react';

type StageVariant = 'headline' | 'jackpot';
type Breakpoints = 'sm' | 'md' | 'lg' | 'xl';
type BreakpointValues = Record<Breakpoints, number>;
type StageContextValue = {
  variant: StageVariant;
  breakpoints: BreakpointValues;
};
type StageProviderProps = Partial<StageContextValue> & { children: React.ReactNode };

const defaultBreakpoints: BreakpointValues = {
  sm: 375,
  md: 768,
  lg: 1024,
  xl: 1280,
};

const StageContext = createContext<StageContextValue | undefined>(undefined);

const StageProvider = ({ breakpoints = defaultBreakpoints, variant = 'headline', children }: StageProviderProps) => {
  return <StageContext.Provider value={{ variant, breakpoints }}>{children}</StageContext.Provider>;
};

const useStage = () => {
  const ctx = useContext(StageContext);
  if (!ctx) throw new Error('useStage must be used inside a <StageProvider />');
  return ctx;
};

export { StageProvider, useStage };
export type { BreakpointValues, StageContextValue, StageVariant };
